import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Subject } from 'rxjs';
import { finalize, first, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Message } from 'src/app/core/class/message';
import { Credentials } from 'src/app/core/models/credentials';
import { AnonymousSignService } from 'src/app/core/services/anonymous-sign.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { VNeIDVerifyingModalComponent } from 'src/app/shared/components/enter-identity-vneid/components/vneid-verifying-modal/vneid-verifying-modal.component';
import { CommonService } from '../../../core/services/common.service';
import { NotificationCmsService } from "../../../core/services/notification-cms.service";
import { SelectVersionComponent } from '../../../shared/components/select-version/select-version.component';
import { LoginBase } from '../login-base';

@Component({
  selector: 'app-login-sso-vneid',
  templateUrl: './login-sso-vneid.component.html',
  styleUrls: ['./login-sso-vneid.component.scss'],
})

export class LoginSsoVneidComponent extends LoginBase implements OnInit, OnDestroy {
  /**
   * the block ui.
   */
  currentLanguage = 'vi';
  isRemember: boolean;
  username: string;
  password: string;
  captcha: string;
  id = 1;
  passwordExpired = false;
  private dialogRef: any;
  credentials: Credentials = new Credentials('', false);

  dataUrlState: any;

  dataLogin: any;
  /**
   * <pre>
   * <b>Method name: constructor</b>
   * <b>Explanation: </b> Method constructor
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private authSer: AuthService,
    private message: Message,
    public commonService: CommonService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public notificationCmsService: NotificationCmsService,
    private anonymousSignService: AnonymousSignService,
  ) {
    super();
    this.dataUrlState = this.router.getCurrentNavigation().extras.state;
    localStorage.removeItem('entType');
    this.commonService.entTypeChange.next(true);
  }
  private unsubscriber : Subject<void> = new Subject<void>();

  /**
   * <pre>
   * <b>Method name: ngOnInit</b>
   * <b>Explanation: </b> Method initial
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  ngOnInit() {
    
    history.pushState(null, '');
    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
      this.authService.logout();
    });
    this.currentLanguage = localStorage.getItem('__language');
    if (!this.currentLanguage) {
      this.currentLanguage = 'vi';
    }
    sessionStorage.clear();
    // re-saving language.
    localStorage.setItem('__language', this.currentLanguage);
    const queryString = window.location.search.substring(1);
    const sessionState = this.getRawQueryParam(queryString, 'session_state');
    const code = this.decodeBase64Param(
      this.getRawQueryParam(queryString, 'code')
    );
    const encryptKey = this.decodeBase64Param(
      this.getRawQueryParam(queryString, 'encrypt_key')
    );

    console.log('sessionState:', sessionState);
    console.log('code:', code);
    console.log('encryptKey:', encryptKey);

    if (sessionState && code && encryptKey) {
      this.loginSsoByVneid(code, encryptKey);
    } else {
      this.router.navigate(['not-found']);
    }
  }
  
  private getRawQueryParam(queryString: string, key: string): string {
    const params = queryString.split('&');
    const param = params.find(item => item.startsWith(`${key}=`));

    if (!param) {
      return '';
    }

    // Lấy giá trị thô sau dấu "="
    return param.substring(key.length + 1);
  }

  private decodeBase64Param(value: string): string {
    try {
      // decodeURIComponent: %2F -> /, %3D -> =
      // Không dùng URLSearchParams để tránh tự chuyển "+" thành khoảng trắng
      return decodeURIComponent(value).replace(/ /g, '+');
    } catch (error) {
      console.error('Lỗi decode URL parameter:', error);
      return '';
    }
  }

  /**
   * On destroy component
   */
  ngOnDestroy() {
  }


   loginSsoByVneid(code: string, encryptKey: string) {
    const body = {
      code,
      encryptKey
    }
     const data = {
        title: this.message.getMessage('kyc.verifying_data'),
        description:
        this.message.getMessage('kyc.the_system_checking'),
    }
    const dialogLoading = this.dialog.open(VNeIDVerifyingModalComponent, {
      width: '400px',
      disableClose: true,
      autoFocus: false,
      ariaLabel: data.title,
      data,
    });
    this.authService.loginSsoByVneid('/auth/login-by-vneid', body).pipe(
      first(),
      finalize(() => {
        dialogLoading.close();
      })
    ).subscribe(
        res => {
          if (res.success) {
              this.dataLogin = res.data;
            /**
             * Nếu có giá trị userService.isDefault == false | không tồn tại thì chưa set default
             * Nếu giá trị userService.isDefault == true thì tiến hành đăng nhập luôn
            */
            if (this.dataLogin.isTwoFactorAuthen) {
              this.anonymousSignService.timeWaitSign.next(this.dataLogin.timeWaitSign);
              this.authService.getListCloudCertificate().subscribe(rs => {
                console.log(rs);
                if (rs && rs.data.length > 0) {
                  this.anonymousSignService.selectedCert.next(rs.data[0]);
                }
              })
              return;
            }
            localStorage.setItem('userServices', JSON.stringify(this.dataLogin.userService.userServices || []))
            if (this.dataLogin.userService && !this.dataLogin.userService.isDefault && this.dataLogin.userService.userServices && this.dataLogin.userService.userServices.length >= 2) {
              sessionStorage.setItem('selectModeYet', 'false');
              this.dialogRef = this.dialog.open(SelectVersionComponent, {
                width: '40%',
                disableClose: true,
                data: {
                  userServices: this.dataLogin.userService.userServices,
                  isLogin: true
                }
              });
              this.dialogRef.afterClosed().subscribe(rs => {
                if (rs && rs.success) {
                  sessionStorage.removeItem('selectModeYet')
                  this.afterLogin(rs.data)
                }
              })
            } else {
              this.afterLogin(this.dataLogin)
            }
          } else {
            this.toastr.error(res.message);
            this.authSer.removeToken();
            localStorage.removeItem('tenantId');
            localStorage.removeItem('userId');
            localStorage.removeItem('fullName');
            localStorage.removeItem('userName');
            localStorage.removeItem('enterpriseId');
            localStorage.removeItem('userType');
            localStorage.removeItem('permissions');
            localStorage.removeItem('defaultPermission');
            localStorage.removeItem('isParent');
            localStorage.removeItem('currentModule');
            localStorage.removeItem('isFromSSO');
            localStorage.removeItem('userServices');
            localStorage.removeItem('isAdminDefault');
            this.router.navigate(['enterprise-login'])
          }
        }
    )
  }

  afterLogin(res) {
    // return
    this.passwordExpired = res.passwordExpired;
    localStorage.setItem('passwordExpired', JSON.stringify(this.passwordExpired));
    localStorage.setItem('dayToExpire', JSON.stringify(res.dayToExpire));
    localStorage.setItem('numberDayShowWarningPassword', JSON.stringify(res.numberDayShowWarningPassword));
    localStorage.setItem('isParent', res.isParent);
    localStorage.setItem('isAdminDefault', res.isAdminDefault);
    localStorage.setItem('userType', res.userType);
    localStorage.setItem('lastChangePassword', res.lastChangePassword);
    localStorage.setItem('isFromSSO', res.isFromSSO);

    if (!res.isVerify) {
      this.redirectAfterLogin('kyc-confirm-account', null)
      return;
    }
    if (res.userType != 0) {
      localStorage.setItem("permissions", JSON.stringify(res.permissions));
      if (this.isRemember === true) {
        this.credentials = new Credentials(this.username, this.isRemember);
        localStorage.setItem('credentialsEnt', JSON.stringify(this.credentials));
      } else {
        localStorage.removeItem('credentialsEnt');
      }

      if (res.userType != 0) {
        localStorage.setItem("permissions", JSON.stringify(res.permissions));
        if (this.isRemember === true) {
          this.credentials = new Credentials(this.username, this.isRemember);
          localStorage.setItem('credentialsEnt', JSON.stringify(this.credentials));
        } else {
          localStorage.removeItem('credentialsEnt');
        }
        if (res.approverNumber) {
          localStorage.setItem('approverNumber', res.approverNumber);
        } else {
          localStorage.removeItem('approverNumber');
        }
        // entType === 2: Loại không chứng thực
        if (res.entType !== undefined) {
          localStorage.setItem('entType', res.entType);
        } else {
          localStorage.removeItem('entType');
        }
        this.commonService.entTypeChange.next(true);
        // this.router.navigate(['home-enterprise']);
      } else {
        this.toastr.error(this.message.getMessage('messages.wrong_credential'));
        this.authSer.removeToken();
        localStorage.removeItem('tenantId');
        localStorage.removeItem('userId');
        localStorage.removeItem('fullName');
        localStorage.removeItem('userName');
        localStorage.removeItem('enterpriseId');
        localStorage.removeItem('userType');
        localStorage.removeItem('permissions');
        localStorage.removeItem('defaultPermission');
        localStorage.removeItem('isParent');
        localStorage.removeItem('currentModule');
        localStorage.removeItem('SignDataValidate');
        localStorage.removeItem('cloudCaMultiSignThreshold');
        localStorage.removeItem('userServices');
        localStorage.removeItem('isFromSSO');
        localStorage.removeItem('lastChangePassword');
      }
      // this.redirectAfterLogin('home-enterprise', null)

    } else {
      this.toastr.error(this.message.getMessage('messages.wrong_credential'));
      this.authSer.removeToken();
      localStorage.removeItem('tenantId');
      localStorage.removeItem('userId');
      localStorage.removeItem('fullName');
      localStorage.removeItem('userName');
      localStorage.removeItem('enterpriseId');
      localStorage.removeItem('userType');
      localStorage.removeItem('permissions');
      localStorage.removeItem('defaultPermission');
      localStorage.removeItem('isParent');
      localStorage.removeItem('currentModule');
      localStorage.removeItem('userServices');
      localStorage.removeItem('isFromSSO');
      localStorage.removeItem('lastChangePassword');
    }
    this.redirectAfterLogin('home-enterprise', { state: this.dataUrlState });
    this.notificationCmsService.getNotification();
  }

  redirectAfterLogin(type, option: any) {
    if (this.passwordExpired) {
      this.router.navigate(['reset-password']);
    }
    else {
      if (option) {
        this.router.navigate([type], option)
      }
      else {
        this.router.navigate([type])
      }
    }
  }
}
